import { mapGetters } from 'vuex';
import AuthMixin from '@/mixins/Auth';
import AuditAdmin from '@/views/Audit/Audit-Admin/Audit-Admin.vue';
import AuditUser from '@/views/Audit/Audit-User/Audit-User.vue';
import Loading from '@/views/Loading.vue'

export default {
    name: 'Audit',

    mixins: [
      AuthMixin,
    ],

    components: {
        AuditAdmin,
        AuditUser,
        Loading,
    },

    computed: {
      ...mapGetters({
          userType: 'auth/userType',
          userRoles: 'auth/userRoles'
        }),
  
      componentToShow() {

        if (this._.isEmpty(this.userRoles)) {
          return 'Loading';
        }

        return  this.userHasRole(['rail_admin', 'rail_manager', 'tracker_admin', 'tracker_manager'])
                ? 'AuditAdmin'
                : 'AuditUser';
      }
    },

    created() {
      this.initialize();
    },

    data() {
      return this.initialState();
    },

    methods: {
      initialize() {
      },

      initialState() {
        return {}
      },
    }
}
